import React, { useState, useContext, useMemo } from 'react';
import axios from '../api/axios';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import './LoginView.css';
import useLocale from '../hooks/useLocale';

const LoginView = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { setUserData } = useContext(UserContext);
  const { getCurrentLanguage } = useLocale();
  const lang = getCurrentLanguage();
  const ucpBaseUrlRaw =
    (typeof process !== 'undefined' && process?.env?.REACT_APP_UCP_BASE_URL) ||
    'https://ucp.academy';

  const ucpBaseUrl = String(ucpBaseUrlRaw || '').replace(/\/$/, '');
  const ucpRegisterUrl = `${ucpBaseUrl}/register`;

  const translations = useMemo(() => {
    if (lang === 'ru') {
      return {
        loginTitle: 'Вход в систему',
        emailLabel: 'Электронная почта',
        passwordLabel: 'Пароль',
        loginButton: 'Войти',
        ucpRegisterButton: 'Зарегистрироваться в UCP',
        ucpInfoTitle: 'Важное',
        ucpInfoText:
          'Чтобы загрузить работу или стать рецензентом, сначала зарегистрируйтесь в UCP по кнопке ниже, затем вернитесь на эту страницу и войдите.',
      };
    } else {
      return {
        loginTitle: 'Login',
        emailLabel: 'Email',
        passwordLabel: 'Password',
        loginButton: 'Login',
        ucpRegisterButton: 'Register in UCP',
        ucpInfoTitle: 'Important',
        ucpInfoText:
          'To upload a paper or become a reviewer, first register in UCP using the button below, then return here and sign in.',
      };
    }
  }, [lang]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const authString = btoa(`${email}:${password}`);
      const response = await axios.get('/auth/login', {
        headers: { Authorization: `Basic ${authString}` },
      });
      // Предполагается, что структура ответа: { user, access_token, refresh_token }
      setUserData(
        response.data.user,
        response.data.access_token,
        response.data.refresh_token,
        response.data.participant_id,
      );
      navigate('/dashboard');
    } catch (err) {
      setError(lang === 'ru' ? 'Неверные учетные данные' : 'Invalid credentials');
      console.error(err);
    }
  };

  return (
    <div className="login-container">
      <div className="login-ucp-info" role="note" aria-live="polite">
        <div className="login-ucp-info__title">{translations.ucpInfoTitle}</div>
        <div className="login-ucp-info__text">{translations.ucpInfoText}</div>
      </div>
      <h1>{translations.loginTitle}</h1>
      <form onSubmit={handleLogin}>
        <div>
          <label htmlFor="email">{translations.emailLabel}</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="password">{translations.passwordLabel}</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">{translations.loginButton}</button>
        <a
          className="login-ucp-register"
          href={ucpRegisterUrl}
          target="_blank"
          rel="nofollow noopener noreferrer"
        >
          {translations.ucpRegisterButton}
        </a>
      </form>
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default LoginView;
